//import NPM, LIB
import React, { useState, useMemo, useEffect } from "react";
import Moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { sub, format } from "date-fns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBrLocale from "date-fns/locale/pt-BR";
import MicroModal from "micromodal";

//import ACTIONS
import convertUnicodeEmoji from "../../../../actions/convertUnicodeEmoji";
import {
  DetailsAnotationsida,
  DownloadFile,
  DetailsFileShared,
  dbfileSize,
  GetInteractionsModal,
} from "../../../../actions";
import { Popover, Tooltippy } from "../../../../actions/Tippy";

//import COMPONENTS
import Typography from "../../../Typography";
import Table from "../../../table";
import Loading from "../../../Loading";

//import CSS
import "./file-share-modal.css";

//import SVG,IMG
import WEBCHAT from "../../../../build/images/webchat.svg";
import WHATSAPP from "../../../../build/images/whatsapp-icon.svg";
import GOOGLEGBM from "../../../../build/images/googlegbm-new.svg";
import { ReactComponent as IconDoc } from "../../../../build/images/attendanceIcons/document-text.svg";
import { ReactComponent as IconCalendar } from "../../../../build/images/Calendar-2.svg";
import { ReactComponent as IconMoreVertical } from "../../../../build/images/MoreVertical.svg";
import { ReactComponent as IconMessageNull } from "../../../../build/images/messages-3.svg";
import TEAMS from "../../../../build/images/channels/teamsMedium.svg";

const { connection_platform } = require("../../../../services/api");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  // if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

let dateinitsearchfile = sub(new Date(), {
  months: 1,
});
let dateendsearchfile = new Date();

let detailsFileShared = [];

export default function NewFileShareModal(props) {
  const dispatch = useDispatch();
  const filesSharedData = useSelector((state) => state.detailsfileshared);
  const contactId = useSelector((state) => state.atendimento);
  const InfoUsers = useSelector((state) => state.informationusers);
  const infoModal = useSelector((state) => state.interactionsmodal);

  const [defaultValueFormat, setDefaultValueFormat] = useState("Todos");
  const [defaultValueMidias, setDefaultValueMidias] = useState("Todos");
  const [midias, setMidias] = useState(
    "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18"
  );
  const [mimetypeids, setMimetypeids] = useState(
    "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28"
  );
  const [buttonShowFormatsFile, setButtonShowFormatsFile] = useState(false);
  const [buttonShowMidias, setButtonShowMidias] = useState(false);
  const [optionsActionsFile, setOptionsActionsFile] = useState([]);
  const [dataInitial, setDataInitial] = useState(dateinitsearchfile);
  const [dataFinal, setDataFinal] = useState(dateendsearchfile);
  const [loading, setLoading] = useState(false);
  const [ContactId, setContactId] = useState({});

  const ShowChoiceFormat = () => {
    setButtonShowFormatsFile(!buttonShowFormatsFile);
  };

  const choiceFormat = (event, formats, name) => {
    setMimetypeids(formats);
    setButtonShowFormatsFile(!buttonShowFormatsFile);
    setDefaultValueFormat(name);
  };

  const choiceMidia = (event, midias, name) => {
    setMidias(midias);
    setButtonShowMidias(!buttonShowMidias);
    setDefaultValueMidias(name);
  };

  const ShowChoiceMidias = () => {
    setButtonShowMidias(!buttonShowMidias);
  };

  const showExpandVisual = (idarq) => {
    var click = optionsActionsFile.indexOf(idarq) != -1 ? true : false;
    var temp = [];

    if (!click) {
      temp = optionsActionsFile.concat([idarq]);
    } else {
      temp = optionsActionsFile.filter(function (val) {
        return val != idarq;
      });
    }
    setOptionsActionsFile(temp);
  };

  const buttonSearchFileCompart = () => {
    var erro = 0;
    const datainit = format(dataInitial, "yyyy-MM-dd");
    const datafim = format(dataFinal, "yyyy-MM-dd");
    const formats = mimetypeids;

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit === "") var erro = 1;

    if (datafim === "") var erro = 1;

    if (formats === "") var erro = 1;

    if (midias === "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      setLoading(true);
      dispatch(
        DetailsFileShared(
          datainit,
          datafim,
          formats,
          midias,
          ContactId.telefone
        )
      );
    }
  };

  function exitModal(e, modal) {
    // if (originModal === "contacts") {
    //   MicroModal.close("modal__historico-atendimento-details");
    //   MicroModal.show("modal__agenda");
    // } else if (originModal === "") {
    MicroModal.close(modal);
    dispatch(GetInteractionsModal("", ""));
    setDataInitial(dateinitsearchfile);
    setDataFinal(dateendsearchfile);
    // }
  }

  function createJSON(item) {
    if (item) {
      var mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1;
      try {
        mensagem_tratada =
          '{"' +
          valor +
          '": [{"mensagem_tratada":"' +
          mensagem_tratada +
          '"}]}';
        var obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada;
      } catch (e) {
        mensagem_tratada = item;
      }
      return mensagem_tratada;
    }
  }

  function defaultSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data;
    const objectRowB = rowB.original[columnId].data;

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;
    return 0;
  }

  function customSorting(rowA, rowB, columnId) {
    const customRowA = rowA.original[columnId].config.customOrder;
    const customRowB = rowB.original[columnId].config.customOrder;

    if (customRowA > customRowB) return -1;
    if (customRowB > customRowA) return 1;
    return 0;
  }

  function channelIcon(idmidia) {
    if (idmidia === 5) {
      return (
        <img src={WHATSAPP} alt="" className="arq-comp__t-channel__icon" />
      );
    } else if (idmidia === 4) {
      return (
        <img
          src="build/images/t-facebook.svg"
          alt=""
          className="arq-comp__t-channel__icon"
        />
      );
    } else if (idmidia === 2) {
      return <img src={WEBCHAT} alt="" className="arq-comp__t-channel__icon" />;
    } else if (idmidia === 11) {
      return (
        <img
          src={GOOGLEGBM}
          alt=""
          width={24}
          height={24}
          className="arq-comp__t-channel__icon"
        />
      );
    } else if (idmidia === 15) {
      return (
        <img
          src={TEAMS}
          alt=""
          width={24}
          height={24}
          className="arq-comp__t-channel__icon"
        />
      );
    }
  }

  const columns = [
    {
      Header: "Canal",
      accessor: "channel",
      id: "channel",
      sortType: customSorting,
      disableFilters: true,
    },
    {
      Header: "Origem",
      accessor: "origin",
      id: "origin",
      sortType: defaultSorting,
      disableFilters: true,
    },
    {
      Header: "Nome",
      accessor: "name",
      id: "name",
      disableFilters: true,
      sortType: defaultSorting,
    },
    {
      Header: "Data",
      accessor: "date",
      id: "date",
      sortType: customSorting,
      disableFilters: true,
    },
    {
      Header: "Tipo",
      accessor: "type",
      id: "type",
      disableFilters: true,
      sortType: defaultSorting,
    },
    {
      Header: "Tamanho",
      accessor: "size",
      id: "size",
      sortType: defaultSorting,
      disableFilters: true,
    },
    {
      Header: "",
      accessor: "action",
      id: "action",
      disableSortBy: true,
      disableFilters: true,
    },
  ];

  function refactorFileShareList(data) {
    let dataRefactored = [];

    data.forEach((datum) => {
      const getName = datum.mensagem.split("/");
      const nameArchive = getName[getName.length - 1];

      const formatDate = datum.data_envio.split(" ");
      const dateGet = formatDate[1];
      const hourGet = formatDate[0];

      const splitDate = dateGet.split("/");
      const reverseDate = splitDate.reverse();
      const dateOrder = `${reverseDate.join("/")} ${hourGet}`;

      const fileShareRefactored = {
        channel: {
          data: channelIcon(datum.idmidia),
          config: {
            textEllipsis: true,
            customOrder: datum.idmidia,
          },
        },
        origin: {
          data: datum.origem_arquivo,
          config: {
            textEllipsis: true,
          },
        },
        name: {
          data: <p data-tooltip={nameArchive}>{nameArchive}</p>,
          config: {
            textEllipsis: true,
          },
        },
        date: {
          data: (
            <div className="date-container">
              <IconCalendar />
              <Typography.Paragraph color={"gray-180"}>
                {dateGet} - {hourGet}
              </Typography.Paragraph>
            </div>
          ),
          config: {
            textEllipsis: true,
            customOrder: new Date(dateOrder),
          },
        },
        type: {
          data: datum.formato,
          config: {
            textEllipsis: true,
          },
        },
        size: {
          data: dbfileSize(datum.filesize),
          config: {
            textEllipsis: true,
          },
        },
        action: {
          data: (
            <Popover
              trigger="click"
              placement="bottom-end"
              content={
                <div className="popover-fileShare">
                  {datum.formato !== "DOCUMENT" && InfoUsers.permdownload && (
                    <div className="popover-fileShare__item">
                      <a
                        className="context__content"
                        href={
                          connection_platform.type_connect +
                          "://" +
                          ipcurrent +
                          datum.mensagem
                        }
                        target="_blank"
                        download
                      >
                        <span className="context__text">Visualizar</span>
                      </a>
                    </div>
                  )}
                  {InfoUsers.permdownload && (
                    <div className="popover-fileShare__item">
                      <div
                        className="context__content"
                        onClick={() =>
                          dispatch(
                            DownloadFile(
                              connection_platform.type_connect +
                                "://" +
                                ipcurrent +
                                datum.mensagem,
                              datum.mensagem
                            )
                          )
                        }
                      >
                        <span className="context__text">Fazer download</span>
                      </div>
                    </div>
                  )}
                </div>
              }
            >
              <IconMoreVertical className="icon-file-actions" />
            </Popover>
          ),
          config: {
            textEllipsis: true,
          },
        },
      };

      dataRefactored.push(fileShareRefactored);
    });

    return dataRefactored;
  }

  const fileShared = useMemo(() => {
    if (filesSharedData.length != 0) {
      const dataRefactored = refactorFileShareList(
        filesSharedData.detailsfileshared
      );
      setLoading(false);
      return dataRefactored;
    }
  }, [filesSharedData]);

  useEffect(() => {
    if (contactId && !infoModal.telefone) {
      setContactId(contactId);
    } else if (infoModal.telefone) {
      setContactId(infoModal);
    } else if (props.ContactId) {
      setContactId(props.ContactId);
    }
  }, [props.ContactId, infoModal, contactId]);

  return (
    <div
      className="modal micromodal-slide"
      id="modal__arquivos-compartilhados-details"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container modal-size"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__arquivos-compartilhados__title"
        >
          <header className="modal__header">
            <Typography.H2 color={"blue-selected-4"} weight={700}>
              Arquivos compartilhados
            </Typography.H2>
            <button
              className="modal__close"
              aria-label="Close modal"
              data-micromodal-close
              onClick={(event) =>
                exitModal(event, "modal__arquivos-compartilhados-details")
              }
            ></button>
          </header>
          <main
            className="modal__content"
            id="modal__arquivos-compartilhados__content"
          >
            <div className="arq-comp__info">
              <Typography.H4 color={"blue-selected-5"}>
                {createJSON(ContactId.cliente)}
              </Typography.H4>
              <div className="modal__info-total">
                <IconDoc />
                <span className="arq-comp__info-text">
                  Total de{" "}
                  <span className="arq-comp__counter">
                    {fileShared && fileShared.length}
                  </span>{" "}
                  arquivo&#x28;s&#x29;
                </span>
              </div>
            </div>
            <div className="arq-comp__sub-panel">
              <p className="arq-comp__text">
                Use os campos abaixo para filtrar a sua pesquisa:
              </p>
              <div className="arq-comp__sub-panel__grid">
                <div className="arq-comp__time-panel">
                  <div className="arq-comp__ctrls">
                    <div className="modal_date-start">
                      <span className="arq-comp__span ml-0">De:</span>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={ptBrLocale}
                      >
                        <DatePicker
                          value={dataInitial}
                          onChange={(newValue) => setDataInitial(newValue)}
                          maxDate={dataFinal}
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="modal_date-end">
                      <span className="arq-comp__span">Até:</span>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={ptBrLocale}
                      >
                        <DatePicker
                          value={dataFinal}
                          onChange={(newValue) => setDataFinal(newValue)}
                          minDate={dataInitial}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>
                <div className="arq-comp__format-panel">
                  <p className="arq-comp__text-minor">Formato:</p>
                  <div style={{ display: "none" }}>
                    <input
                      type="text"
                      defaultValue={
                        "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28"
                      }
                      //   ref={input => (this.mimetypeids = input)}
                      className="mimetype"
                    />
                    <input
                      type="text"
                      defaultValue={"2,4,5"}
                      //   ref={input => (this.midias = input)}
                      className="midias"
                    />
                  </div>
                  <div className="arq-comp__ctrls">
                    <button
                      type="date"
                      className="arq-comp__format-btn"
                      onClick={() => ShowChoiceFormat()}
                    >
                      {defaultValueFormat}{" "}
                      <span className="material-icons">expand_more</span>
                    </button>
                    <ul
                      className={
                        buttonShowFormatsFile
                          ? "arq-comp__list arq-comp__format-list active"
                          : "arq-comp__list arq-comp__format-list"
                      }
                    >
                      <li
                        className="arq-comp__item"
                        onClick={(event) =>
                          choiceFormat(
                            event,
                            "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28",
                            "Todos"
                          )
                        }
                      >
                        Todos
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "5", "PDF")}
                      >
                        PDF
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) =>
                          choiceFormat(event, "10,11,14", "DOC")
                        }
                      >
                        DOC
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "8,9", "XLS")}
                      >
                        XLS
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "12,13", "PPT")}
                      >
                        PPT
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "7", "ZIP")}
                      >
                        ZIP
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) =>
                          choiceFormat(event, "3,18", "Imagem")
                        }
                      >
                        Imagem
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) =>
                          choiceFormat(event, "4,6,15,17", "Áudio")
                        }
                      >
                        Áudio
                      </li>
                      <li
                        className="arq-comp__item"
                        onClick={(event) => choiceFormat(event, "16", "Vídeo")}
                      >
                        Vídeo
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="arq-comp__channel-panel">
                  <p className="arq-comp__text-minor">Canal:</p>
                  <div className="arq-comp__ctrls">
                    <button
                      type="date"
                      onClick={() => ShowChoiceMidias()}
                      className="arq-comp__channel-btn"
                    >
                      {defaultValueMidias}{" "}
                      <span className="material-icons">expand_more</span>
                    </button>
                    <ul
                      className={
                        buttonShowMidias
                          ? "arq-comp__list arq-comp__format-list active"
                          : "arq-comp__list arq-comp__format-list"
                      }
                    >
                      <li
                        className="arq-comp__item"
                        id="Todos"
                        onClick={(event) =>
                          choiceMidia(event, "5,4,2,11", "Todos")
                        }
                      >
                        Todos
                      </li>
                      <li
                        className="arq-comp__item"
                        id="Whatsapp"
                        onClick={(event) => choiceMidia(event, "5", "Whatsapp")}
                      >
                        Whatsapp
                      </li>
                      <li
                        className="arq-comp__item"
                        id="Facebook"
                        onClick={(event) => choiceMidia(event, "4", "Facebook")}
                      >
                        Facebook
                      </li>
                      <li
                        className="arq-comp__item"
                        id="Webchat"
                        onClick={(event) => choiceMidia(event, "2", "Webchat")}
                      >
                        Webchat
                      </li>
                      <li
                        className="arq-comp__item"
                        id="Google GBM"
                        onClick={(event) =>
                          choiceMidia(event, "11", "Google GBM")
                        }
                      >
                        Google GBM
                      </li>
                      <li
                        className="arq-comp__item"
                        id="Teams"
                        onClick={(event) => choiceMidia(event, "15", "Teams")}
                      >
                        Teams
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="arq-comp__btn">
                  <button
                    className={`btn-modals ${loading ? "search-time" : ""}`}
                    onClick={(event) =>
                      loading ? null : buttonSearchFileCompart(event)
                    }
                  >
                    Filtrar
                  </button>
                </div>
              </div>

              <div className="arq-comp__content">
                <div className="arq-comp__table">
                  {loading ? (
                    <Loading.Paperplane fullPage={true} loadingModal />
                  ) : fileShared && fileShared.length > 0 ? (
                    <Table
                      className="table-fileShare"
                      data={fileShared}
                      columns={columns}
                      fixedHeader
                      // fixedFirstColumn
                      // filtersActive={filtersActive}
                      // emptyState={emptyState}
                      // setEmptyState={setEmptyState}
                      // initialState={sortBy}
                      // screen="manager"
                    />
                  ) : (
                    <div className="modal__nully">
                      <div className="modal__nully-icon">
                        <IconMessageNull />
                      </div>
                      <div className="modal__nully-text">
                        <Typography.H4 color={"black"}>
                          Não há nenhum arquivo compartilhado.
                        </Typography.H4>
                      </div>
                    </div>
                  )}
                  {/* <div className="arq-comp__t-head">
                    <div className="arq-comp__t-col1 sort-by__btn">
                      <i className="material-icons">sort_by_alpha</i>
                    </div>
                    <div className="arq-comp__t-col2">Nome:</div>
                    <div className="arq-comp__t-col3">Data:</div>
                    <div className="arq-comp__t-col4">Tamanho:</div>
                    <div className="arq-comp__t-col5">Canal:</div>
                  </div>
                  <div className="arq-comp__t-body">
                    {detailsFileShared.map((dfilesh) => (
                      <div
                        className="arq-comp__t-item"
                        id="01"
                        key={dfilesh.id}
                        onClick={() => showExpandVisual(dfilesh.id)}
                      >
                        <div
                          className={
                            optionsActionsFile.indexOf(dfilesh.id) != -1
                              ? "arq-comp__t-item__context id-01 active"
                              : "arq-comp__t-item__context id-01"
                          }
                        >
                          <div className="context__label special">
                            <a
                              className="context__content"
                              href={
                                connection_platform.type_connect +
                                "://" +
                                ipcurrent +
                                dfilesh.mensagem
                              }
                              target="_blank"
                              download
                            >
                              <span className="material-icons">visibility</span>
                              <span className="context__text">Visualizar</span>
                            </a>
                          </div>
                          <div className="context__label">
                            <div
                              className="context__content"
                              onClick={() =>
                                dispatch(
                                  DownloadFile(
                                    connection_platform.type_connect +
                                      "://" +
                                      ipcurrent +
                                      dfilesh.mensagem,
                                    dfilesh.mensagem
                                  )
                                )
                              }
                            >
                              <span className="material-icons">get_app</span>
                              <span className="context__text">
                                Fazer download
                              </span>
                            </div>
                          </div>
                          
                        </div>
                        <div className="arq-comp__t-sort">
                          <span className="arq-comp__t-sort_ft">
                            {dfilesh.formato}
                          </span>
                        </div>
                        <div className="arq-comp__t-name">
                          Arquivo em {dfilesh.formato}
                        </div>
                        <div className="arq-comp__t-date">
                          {dfilesh.data_envio}
                        </div>
                        {(() => {
                          var url =
                            connection_platform.type_connect +
                            "://" +
                            ipcurrent +
                            dfilesh.mensagem;
                          {
                            dbfileSize(dfilesh.filesize);
                          }
                          
                        })()}
                        <div className="arq-comp__t-size">
                          {dbfileSize(dfilesh.filesize)}
                        </div>
                        <div className="arq-comp__t-channel">
                          {(() => {
                            if (dfilesh.idmidia === 5) {
                              return (
                                <img
                                  src={WHATSAPP}
                                  alt=""
                                  className="arq-comp__t-channel__icon"
                                />
                              );
                            } else if (dfilesh.idmidia === 4) {
                              return (
                                <img
                                  src="build/images/t-facebook.svg"
                                  alt=""
                                  className="arq-comp__t-channel__icon"
                                />
                              );
                            } else if (dfilesh.idmidia === 2) {
                              return (
                                <img
                                  src={WEBCHAT}
                                  alt=""
                                  className="arq-comp__t-channel__icon"
                                />
                              );
                            }
                          })()}
                        </div>
                      </div>
                    ))}
                  </div> */}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
